import {
  GET_RECEIPTS,
  GET_RECEIPTS_SUCCESS,
  GET_RECEIPTS_ERROR,
  CREATE_RECEIPT,
  CREATE_RECEIPT_SUCCESS,
  CREATE_RECEIPT_ERROR,
  EXPORT_RECEIPTS,
  EXPORT_RECEIPTS_SUCCESS,
  EXPORT_RECEIPTS_ERROR,
  GET_RECEIPT_TYPES,
  GET_RECEIPT_TYPES_SUCCESS,
  GET_RECEIPT_TYPES_ERROR,
  CREATE_RECEIPT_TYPES,
  CREATE_RECEIPT_TYPES_SUCCESS,
  CREATE_RECEIPT_TYPES_ERROR,
} from "./actionTypes"
import {
  handleGetCampaignFulfillment,
  handleGetCampaignFulfillmentError,
  handleGetCampaignFulfillmentSuccess,
} from "helpers/campaign_fulfillment_pagination_helper"

const INIT_STATE = {
  receipts: [],
  error: null,
  loading: false,
  export_loading: false,
  creating_receipt: false,
  last_page_fetched: 0,
  last_fetched_at: null,
  total_number_of_pages: 0,
  has_next_page: false,
  has_lookahead_pages: false,
  active_cache_key: null,
  page_cache: {},
  last_start_date: null,
  last_end_date: null,
  last_transaction_date: null,
  last_transaction_amount: null,
  receipt_types: [],
  loading_receipt_types: false
}
const Receipts = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_RECEIPTS:
      return handleGetCampaignFulfillment(state, action, 'receipts', { loadingKey: 'loading' })

    case GET_RECEIPTS_SUCCESS: {
      const additional = action.payload?.additional_data || {}
      const nextState = handleGetCampaignFulfillmentSuccess(state, action, 'receipts', { loadingKey: 'loading' })

      return {
        ...nextState,
        creating_receipt: false,
        last_start_date: additional.start_date ?? state.last_start_date,
        last_end_date: additional.end_date ?? state.last_end_date,
        last_transaction_date: additional.last_transaction_date ?? state.last_transaction_date,
        last_transaction_amount: additional.last_transaction_amount ?? state.last_transaction_amount,
      }
    }

    case GET_RECEIPTS_ERROR:
      return {
        ...handleGetCampaignFulfillmentError(state, action, 'receipts', { loadingKey: 'loading' }),
        creating_receipt: false,
      }
    case CREATE_RECEIPT:
      return {
        ...state,
        loading: true,
        creating_receipt: true,

      }
    case CREATE_RECEIPT_SUCCESS:
      return {
        ...state,
        receipts: [...state.receipts, action.payload],
        loading: false,
        creating_receipt: false,

      }

    case CREATE_RECEIPT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        creating_receipt: false,

      }
    case EXPORT_RECEIPTS:
      return {
        ...state,
        export_loading: true,
      }
    case EXPORT_RECEIPTS_ERROR:
      return {
        ...state,
        error: action.payload,
        export_loading: false,

      }
    case EXPORT_RECEIPTS_SUCCESS:
      return {
        ...state,
        export_loading: false,

      }
    case GET_RECEIPT_TYPES:
      return {
        ...state,
        loading_receipt_types: true,
        error: null
      }

    case GET_RECEIPT_TYPES_SUCCESS:
      return {
        ...state,
        loading_receipt_types: false,
        receipt_types: action.payload
      }

    case GET_RECEIPT_TYPES_ERROR:
      return {
        ...state,
        loading_receipt_types: false,
        error: action.payload
      }
    case CREATE_RECEIPT_TYPES:
      return {
        ...state,
        loading: true
      }

    case CREATE_RECEIPT_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        receipt_types: [...state.receipt_types, action.payload]
      }

    case CREATE_RECEIPT_TYPES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default Receipts
